import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    flexGrow: 0,
    padding: theme.spacing(3, 2),
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper
  },
  message: { paddingTop: theme.spacing(1) }
}));

const NoResourcesMessage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="subtitle1">
        <FormattedMessage id="vendorResourceAssignmentDialog.noResourcesMessage" />
      </Typography>
      <div className={classes.message}>
        <FormattedMessage id="vendorResourceAssignmentDialog.adjustFilterMessage" />
      </div>
    </div>
  );
};

export default NoResourcesMessage;
